export const globalUser = {
    globalUserID : null,
    setglobalUserID: function(value){
        globalUser.globalUserID = value;
    }
};